// @ts-nocheck — TODO: Add proper types (Phase 7)
import { useAuth } from '@/context';

/**
 * Roles that require MFA enrollment for HIPAA compliance.
 * All clinical roles must have passkeys enrolled.
 */
const MFA_REQUIRED_ROLES = ['admin', 'doctor', 'nurse', 'provider'];

/**
 * Hook to enforce MFA enrollment for clinical roles.
 *
 * @returns {{
 *   mfaRequired: boolean,   - Whether the user's role requires MFA
 *   mfaEnrolled: boolean,   - Whether the user has passkeys enrolled
 *   mfaEnforced: boolean,   - True if role requires MFA AND user has NOT enrolled (must enroll)
 *   isLoading: boolean       - True while checking enrollment status
 * }}
 */
const useMFAEnforcement = () => {
  const { role, hasPasskeys } = useAuth();

  // Skip MFA enforcement entirely in emulator mode
  const isEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';
  const mfaRequired = isEmulator ? false : MFA_REQUIRED_ROLES.includes(role);
  const webAuthnSupported =
    typeof window !== 'undefined' &&
    typeof window.PublicKeyCredential !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    typeof navigator.credentials?.create === 'function';
  const mfaEnrolled = mfaRequired && webAuthnSupported && hasPasskeys === true;

  return {
    mfaRequired,
    mfaEnrolled,
    mfaEnforced: mfaRequired && !mfaEnrolled,
    isLoading: false,
  };
};

export default useMFAEnforcement;
